import { format, parseISO } from 'date-fns';
import type { FC} from 'react';
import { memo } from 'react';

import { CalendaSize12, OfflineIconSize14, OnlineIconSize14 } from '@shared/assets';

import { parseAddress } from '@src/library/helpers/events/address';
import type { Event } from '@src/library/models/events';

import * as st from './styles.module.scss';

interface Props {
	event: Event;
}

export const EventAcquiredCard: FC<Props> = memo(({ event }) => {
	return (
		<div className={st.event}>
			<img className={st.image} src={event.event_image} alt="" />

			<div className={st.data}>
				<div className={st.info}>
					<h3 className={st.title}>{event.title}</h3>
					<div className={st.duration}>
						<div className={st.data__date}>
							<CalendaSize12 />
							<span>{`${format(parseISO(event.time_from), 'dd.MM.yyyy')}`}</span>
						</div>
						<div className={st.data__place}>
							{event.mode === 'N' ? <OnlineIconSize14 /> : <OfflineIconSize14 />}
							<span className={st.data__place__name}>
								{event.mode === 'N' ? 'Онлайн' : parseAddress(event.address)}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
